import React from 'react'

import { cn } from '@/lib/utils'

import { StylesProps } from '../page-header.types'
import { HeaderBanner } from '../shared/header-banner'
import { HeaderDescription } from '../shared/header-description'
import { HeaderLogo } from '../shared/header-logo'
import { HeaderName } from '../shared/header-name'
import { HeaderSocialIcons } from '../shared/header-social-icons'

export const GeexBarberPageHeader = ({
  page,
  hasLogoImage,
  hasBannerImage,
  forceMobile,
  ...props
}: StylesProps) => {
  return (
    <>
      <div className={cn('p-fluid-4', { 'lg:pt-fluid-14': !forceMobile })}>
        <div className="relative text-page-text">
          <div
            className={cn('relative', {
              'pt-[99px]': !hasBannerImage,
            })}
          >
            <HeaderBanner
              media={page?.bannerMedia}
              className="h-fluid-72 w-full rounded-page-widget"
              {...props}
              style={
                hasLogoImage
                  ? {
                      maskImage: `linear-gradient(black, black),url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjY2IiB2aWV3Qm94PSIwIDAgMTIwIDY2IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cGF0aCBkPSJNMC41IDMwQzAuNSAxMy40MzE1IDEzLjkzMTUgMCAzMC41IDBIOTBDMTA2LjU2OSAwIDEyMCAxMy40MzE1IDEyMCAzMFY2NkgwLjVWMzBaIiBmaWxsPSIjRDlEOUQ5Ii8+Cjwvc3ZnPgo=')`,
                      maskRepeat: 'no-repeat',
                      maskPosition: 'center bottom',
                      maskComposite: 'exclude',
                      WebkitMaskImage: `linear-gradient(black, black),url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjY2IiB2aWV3Qm94PSIwIDAgMTIwIDY2IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cGF0aCBkPSJNMC41IDMwQzAuNSAxMy40MzE1IDEzLjkzMTUgMCAzMC41IDBIOTBDMTA2LjU2OSAwIDEyMCAxMy40MzE1IDEyMCAzMFY2NkgwLjVWMzBaIiBmaWxsPSIjRDlEOUQ5Ii8+Cjwvc3ZnPgo=')`,
                      WebkitMaskRepeat: 'no-repeat',
                      WebkitMaskPosition: 'center bottom',
                      WebkitMaskComposite: 'exclude',
                    }
                  : undefined
              }
            />

            <HeaderLogo
              media={page?.logoMedia}
              {...props}
              className="absolute bottom-[-45px] left-1/2 -translate-x-1/2 rounded-[20px]"
              sizeClassName="size-[99px]"
              size={99}
            />
          </div>

          <div
            className={cn('flex flex-col space-y-fluid-2 px-fluid-4 pt-5', {
              'pt-[72px]': hasLogoImage,
            })}
          >
            <HeaderName
              name={page?.name}
              {...props}
              className="text-center text-fluid-3xl"
            />

            <HeaderDescription
              description={page?.description}
              {...props}
              className="text-center text-fluid-base"
            />

            <HeaderSocialIcons
              socialIcons={page?.socialIcons}
              {...props}
              className="mt-fluid-5! justify-center"
              primaryClassName="p-fluid-6 page-header-primary-button min-w-fluid-64"
              type="PRIMARY"
              showPrimaryLabel
            />
          </div>
        </div>
      </div>

      <div className="p-fluid-4 pt-fluid-0">
        <HeaderSocialIcons
          socialIcons={page?.socialIcons}
          {...props}
          className="justify-center"
          secondaryClassName="p-fluid-4 page-header-secondary-button rounded-page-widget!"
          type="SECONDARY"
        />
      </div>
    </>
  )
}
